import React from 'react'
import { Link } from 'react-router-dom'
import { usePath } from 'lib/core/hooks'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { Title } from '../../../../components/Styled'
import { Note } from './styled'

export const Heading = () => {
  const path = usePath()

  return (
    <>
      <FlexWrapper className='flex-title'>
        <Title>
          Your Subscription
        </Title>
        <Link to='/customer/account/subscriptions'>Back</Link>
      </FlexWrapper>
      <Note>
        <strong>
          Subscriptions are shipped to your default shipping address. Manage your addresses <Link to={`${path.customer}/account/addresses`}>here</Link>.
        </strong>
        <br />
        Ordering a product for someone else? Please set up a separate account <Link to={path.createAccount}>here</Link>.
      </Note>
    </>
  )
}
